import { BANNER_VARIANTS } from '@/app.constants';
import React from 'react';
import InfoFilled from './InfoFilled';
import Warning from './Warning';

interface IconProps {
  variant: keyof typeof BANNER_VARIANTS;
  size?: number;
}

const Icons: React.FC<IconProps> = ({ variant }) => {
  const iconMap: Record<string, React.ReactNode> = {
    [BANNER_VARIANTS.WARNING]: <Warning />,
    [BANNER_VARIANTS.INFO]: <InfoFilled />,
    // [BANNER_VARIANTS.DANGER]: <ErrorFilled size={size} />,
    // [BANNER_VARIANTS.SUCCESS]: <Tick fillColor='var(--bs-success)'/>,
    // [BANNER_VARIANTS.NEUTRAL]: <Settings iswhite={false} fillColor='var(--bs-purple)' height={20} width={20} />
  };

  return iconMap[variant] || null;
};

export default Icons;
